module.exports = __webpack_public_path__ + "static/media/healthcare.e01bf986.png";